'use client';

export default function TestPage() {
  return (
    <pre>
      {new Date().toString()}
      {'\n'}
      {new Date().toISOString()}
      {'\n'}
      {Intl.DateTimeFormat().resolvedOptions().timeZone}
    </pre>
  );
}
